import { CallLog } from "@/services/call.service";

/**
 * Billable talk time for a call, in whole seconds.
 *
 * Prefers the stored duration, then answered_at -> ended_at: a call that was
 * never answered (answered_at IS NULL) has no billable talk time, so it reads
 * 0 instead of the ringing interval. Legacy rows with no answered_at fall back
 * to started_at -> ended_at, and a handful of old rows recorded milliseconds.
 */
export const callDurationSeconds = (call: CallLog): number => {
  let seconds: number | null = call.duration;

  if (!seconds) {
    if (call.answered_at && call.ended_at) {
      const start = new Date(call.answered_at).getTime();
      const end = new Date(call.ended_at).getTime();
      seconds = Math.max(0, Math.floor((end - start) / 1000));
    } else if (call.answered_at === null || !call.started_at || !call.ended_at) {
      return 0;
    } else {
      const start = new Date(call.started_at).getTime();
      const end = new Date(call.ended_at).getTime();
      seconds = Math.floor((end - start) / 1000);
    }
  }

  return seconds > 100000 ? Math.floor(seconds / 1000) : Math.floor(seconds);
};

/** Talk time as m:ss, the way the Call History table shows it. */
export const formatCallDuration = (call: CallLog): string => {
  const seconds = callDurationSeconds(call);
  return `${Math.floor(seconds / 60)}:${(seconds % 60).toString().padStart(2, "0")}`;
};
